/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SddMandate
 */
export interface SddMandate {
    /**
     * Mandate ID
     * @type {number}
     * @memberof SddMandate
     */
    id?: number;
    /**
     * Mandate status<br/>0 = Pending validation.<br/>5 = Validated, First SDD to be done.<br/>6 = Enabled.<br/>8 = Disabled.<br/>9 = Rejected.<br/>
     * @type {number}
     * @memberof SddMandate
     */
    status?: SddMandateStatusEnum;
    /**
     * IBAN associated to the mandate
     * @type {string}
     * @memberof SddMandate
     */
    iBAN?: string;
    /**
     * SWIFT code associated to the mandate
     * @type {string}
     * @memberof SddMandate
     */
    bIC?: string;
    /**
     * Holder of the IBAN
     * @type {string}
     * @memberof SddMandate
     */
    holder?: string;
    /**
     * Unique mandate reference
     * @type {string}
     * @memberof SddMandate
     */
    uniqueMandateReference?: string;
}


/**
 * @export
 */
export const SddMandateStatusEnum = {
    NUMBER_0: 0,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_8: 8,
    NUMBER_9: 9
} as const;
export type SddMandateStatusEnum = typeof SddMandateStatusEnum[keyof typeof SddMandateStatusEnum];


/**
 * Check if a given object implements the SddMandate interface.
 */
export function instanceOfSddMandate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SddMandateFromJSON(json: any): SddMandate {
    return SddMandateFromJSONTyped(json, false);
}

export function SddMandateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SddMandate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'iBAN': !exists(json, 'IBAN') ? undefined : json['IBAN'],
        'bIC': !exists(json, 'BIC') ? undefined : json['BIC'],
        'holder': !exists(json, 'holder') ? undefined : json['holder'],
        'uniqueMandateReference': !exists(json, 'UniqueMandateReference') ? undefined : json['UniqueMandateReference'],
    };
}

export function SddMandateToJSON(value?: SddMandate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'status': value.status,
        'IBAN': value.iBAN,
        'BIC': value.bIC,
        'holder': value.holder,
        'UniqueMandateReference': value.uniqueMandateReference,
    };
}

